import React from 'react';

/**
 * Esta función cambiará el texto ingresado a un nuevo texto en formato nombre propio.
 *
 * @param text Texto a transformar
 * @returns `string`
 */
export function formatName(text: string): string {
	const words = text
		.toLowerCase()
		.replace('s. a. s.', 'S.A.S.')
		.replace('s.a.s.', 'S.A.S.')
		.replace('s.a.s', 'S.A.S.')
		.replace('s. a.', 'S.A.')
		.replace('s.a.', 'S.A.')
		.replace('s.a', 'S.A.')
		.split(' ');

	return words
		.filter((w) => w.length >= 1)
		.map((word) => {
			// Ignoramos la transformación a 'S.A.' y 'S.A.S.'.
			if (['S.A.', 'S.A.S.'].includes(word)) {
				return word.toUpperCase();
			}

			// Ignoramos los conectores lógicos (Siempre irán en minúscula)
			if (['con', 'de', 'para', 'desde', 'hasta', 'y', 'o', 'u', 'ó', 'e'].includes(word)) {
				return word;
			}

			return word[0].toUpperCase() + word.slice(1);
		})
		.join(' ');
}

export function verifyAccents(str: string): boolean {
	const letters = str.split('');
	for (const letter of letters) {
		if (['`', '´', '^'].includes(letter)) {
			return true;
		}
	}

	return false;
}

export function onlyNumberAndLetter(e: React.KeyboardEvent<HTMLDivElement>) {
	const tecla = document.all ? e.keyCode : e.which;

	//Tecla de retroceso para borrar, siempre la permite
	if (tecla == 8 || tecla == 32) {
		return true;
	}

	// Patrón de entrada, en este caso solo acepta numeros y letras
	const patron = /[A-Za-z0-9]/;
	const tecla_final = String.fromCharCode(tecla);

	if (!patron.test(tecla_final)) {
		e.preventDefault();
		return false;
	}
}

export function onlyNumberAndLetterRazonSocial(e: React.KeyboardEvent<HTMLDivElement>) {
	const tecla = document.all ? e.keyCode : e.which;
	//Tecla de retroceso para borrar, siempre la permite
	if (
		tecla == 8 ||
		tecla == 32 ||
		tecla == 95 ||
		tecla == 45 ||
		tecla == 241 ||
		tecla == 47 ||
		tecla == 46 ||
		tecla == 225 ||
		tecla == 233 ||
		tecla == 237 ||
		tecla == 243 ||
		tecla == 250 ||
		tecla == 209 ||
		tecla == 193 ||
		tecla == 201 ||
		tecla == 205 ||
		tecla == 211 ||
		tecla == 218
	) {
		return true;
	}

	// Patrón de entrada, en este caso solo acepta numeros y letras
	const patron = /[A-Za-z0-9]/;
	const tecla_final = String.fromCharCode(tecla);

	if (!patron.test(tecla_final)) {
		e.preventDefault();
		return false;
	}
}
